import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Snackbar,
  SnackbarContent,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import AdminNavigation from "./adminNavigation";
import LiqueModal from "../customer/components/liqueModal";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import TrashIcon from "../assets/icon/TrashIcon";
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { btnStyleContrast, btnStyleOutlined, lightergrayHex, headerStyleContrast, subHeaderStyleContrast, textStyleContrast } from "../helper/style";
import DiscountService from "../services/manager/discountService";
import { NumericFormat } from "react-number-format";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default function ReviewDiscount() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [msgSuccess, setmsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [listDiscount, setListDiscount] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [errors, setErrors] = useState({});

  const [updateId, setUpdateId] = useState(null);
  const [discountCode, setDiscountCode] = useState("");
  const [description, setDescription] = useState("");
  const [discountType, setDiscountType] = useState("P");
  const discountTypeArr = [
    { value: "P", title: "Persen"}, 
    { value: "H", title: "Harga"}, 
  ];
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountStart, setDiscountStart] = useState(null);
  const [discountEnd, setDiscountEnd] = useState(null);
  const [minSpend, setMinSpend] = useState(null);
  const [maxDisc, setMaxDisc] = useState(null);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPage, setTotalPage] = useState(1);

  const [loading, setLoading] = useState(false);

  const activateSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const validate = () => {
    let tempErrors = {};

    if (!discountCode) {
      tempErrors.discountCode = "Kode diskon harus diisi";
    }

    if (discountAmount <= 0) {
      tempErrors.discountAmount = "Potongan diskon harus lebih dari 0";
    }

    if (minSpend < 0) {
      tempErrors.minSpend = "Minimum pembelanjaaan tidak boleh negatif"
    }

    if (maxDisc <= 0) {
      tempErrors.maxDisc = "Diskon maksimal harus lebih dari 0";
    }

    if (discountType === 'P' && parseInt(discountAmount) > 100) {
      tempErrors.discountAmount = "Potongan diskon tidak boleh lebih dari 100";
    }

    if (discountStart === null) {
      tempErrors.discountStart = "Tanggal start diskon harus diisi";
    }

    if (discountEnd === null) {
      tempErrors.discountEnd = "Tanggal end diskon harus diisi";
    }
    
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  }

  const resetFields = () => {
    setErrors({});
    setDiscountCode("");
    setDescription("");
    setDiscountType("P");
    setDiscountAmount("0");
    setDiscountStart(null);
    setDiscountEnd(null);
    setMinSpend(0);
    setMaxDisc(0)
  };
  
  const handleOpenAdd = () => {
    setOpenAdd(true);
  }

  const handleCloseAdd = () => {
    setOpenAdd(false);
    resetFields();
  }

  const handleOpenEdit = (discount) => {
    setUpdateId(discount.id);
    setDiscountCode(discount.discountCode);
    setDescription(discount.description);
    setDiscountType(discount.discountType);
    setDiscountAmount(discount.discountAmount);
    setMinSpend(discount.minSpend);
    setMaxDisc(discount.maxDiscount);
    setDiscountStart(dayjs(discount.discountStart));
    setDiscountEnd(dayjs(discount.discountEnd));

    setOpenEdit(true);
  }

  const handleCloseEdit = () => {
    setOpenEdit(false);

    setUpdateId(null);
    resetFields();
  }

  const handleOpenDelete = (discount) => {
    setUpdateId(discount.id);
    setOpenDelete(true);
  }

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setUpdateId(null);
  }

  const onAmountChange = (amount) => {
    setDiscountAmount(amount);
    if (discountType === "H") {
      setMaxDisc(amount);
    }
  }

  const onChangeType = (type) => {
    setDiscountType(type);
    if (type === "H") {
      setMaxDisc(discountAmount)
    }
  }

  const getListDiscount = async () => {
    try {
      const response = await DiscountService.getListDiscount(page, perPage, search);
      if (response) {
        const data = response.data;
        setListDiscount(data.discountList);
        setTotalItem(data.totalData);
        setTotalPage(data.totalPage);
      }
    } catch (error) {
      console.error(error);
      setMsgError("Error while fetching list discounts");
      activateError();
    }
  }

  const addDiscount = async () => {
    if (!validate()) {
      return;
    }

    try {
      setLoading(true);
      const response = await DiscountService.addDiscount(
        discountCode,
        discountType,
        discountAmount,
        discountStart.format("YYYY-MM-DD"),
        discountEnd.format("YYYY-MM-DD"),
        description,
        minSpend,
        maxDisc
      );

      if (response) {
        handleCloseAdd();
        setmsgSuccess("Berhasil tambah diskon");
        activateSuccess();

        setPage(1);
        getListDiscount();
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 400) {
        const data = error.response.data;
        setMsgError(data.message);
      } else {
        setMsgError("Gagal tambah diskon");
      }
      activateError();
    } finally {
      setLoading(false);
    }
  }

  const updateDiscount = async () => {
    if (!validate()) {
      return;
    }

    try {
      setLoading(true);
      const response = await DiscountService.updateDiscount(
        updateId,
        discountType,
        discountAmount,
        discountStart.format("YYYY-MM-DD"),
        discountEnd.format("YYYY-MM-DD"),
        description,
        minSpend,
        maxDisc
      );

      if (response) {
        handleCloseEdit();
        setmsgSuccess("Berhasil ubah diskon");
        activateSuccess();

        setPage(1);
        getListDiscount();
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 400) {
        const data = error.response.data;
        setMsgError(data.message);
      } else {
        setMsgError("Gagal ubah diskon");
      }
      activateError();
    } finally {
      setLoading(false);
    }
  }

  const deleteDiscount = async () => {
    try {
      setLoading(true);
      const response = await DiscountService.deleteDiscount(updateId);
      if (response) {
        handleCloseDelete();
        getListDiscount();

        setmsgSuccess("Hapus diskon sukses");
        activateSuccess();
      }
    } catch (error) {
      console.error(error);
      setMsgError("Gagal hapus diskon");
      activateError();
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getListDiscount();
  }, []);
  
  const searchTimeout = useRef(null);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      setPage(1);
      getListDiscount();
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [search]);

  useEffect(() => {
    getListDiscount();
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <Box>
      <CssBaseline />
      <AdminNavigation />
      <Container
        component="main"
        maxWidth="xl"
      >
        <RootContainer>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showSuccess}
            autoHideDuration={3000}
            onClose={() => setShowSuccess(false)}
          >
            <SnackbarContent
              sx={{ backgroundColor: "#19B600" }} 
              message={msgSuccess}/>
          </Snackbar>
    
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={showError}
            autoHideDuration={3000}
            onClose={() => setShowError(false)}
          >
            <SnackbarContent 
              sx={{ backgroundColor: "#E50B0B" }} 
              message={msgError}/>
          </Snackbar>

          <Grid container spacing={1} alignItems="center" marginBottom={2}>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...headerStyleContrast }}>
                Kelola Diskon
              </Typography>
            </Grid>
            <Grid item xs={6} sm={8} md={4}>
              <TextField
                fullWidth
                value={search}
                placeholder="Cari Diskon..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{ 
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Button 
                endIcon={<AddIcon sx={{ color: "white" }} />}
                style={{ ...btnStyleContrast, borderRadius: "50px", width: "100%" }}
                onClick={handleOpenAdd}>
                Tambah Diskon
              </Button>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "20px", width: "100%" }} marginBottom={3}>
            {
              listDiscount.map(discount => (
                <Box  
                  key={discount.id}
                  sx={{ background: "white", borderRadius: "16px", padding: "16px", marginBottom: "20px", boxShadow: "2px 2px 10px rgba(0, 0, 0, .2)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} display="flex" gap="20px" alignItems="center">
                      <Typography sx={{ ...textStyleContrast, color: lightergrayHex }} display="flex" alignItems="center" gap="10px">
                        <CalendarTodayOutlinedIcon /> <span>Last Update: {discount.lastUpdate}</span>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography sx={{ ...subHeaderStyleContrast }}>
                        { discount.discountCode }
                      </Typography>
                      <Typography sx={{ ...textStyleContrast }}>
                        { discount.description }
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} display="flex" justifyContent="end" alignItems="end" gap="10px">
                      <Button 
                        sx={{ ...btnStyleContrast, borderRadius: "50px", width: "120px" }}
                        endIcon={<EditOutlinedIcon />}
                        onClick={() => handleOpenEdit(discount)}
                      >
                        Edit
                      </Button>
                      <Button 
                        sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "120px", color: "red", border: "1px solid red" }}
                        endIcon={<TrashIcon color="red" />}
                        onClick={() => handleOpenDelete(discount)}
                      >
                        Delete
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ))
            }

            <Box display="flex" justifyContent="center">
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'black', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'black', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'black !important', 
                    color: 'white', 
                  },
                }} 
                size="small"
                count={totalPage} 
                page={page}
                onChange={(_event, page) => setPage(page)} />
            </Box>
          </Box>
        </RootContainer>

        <LiqueModal open={openAdd} onClose={handleCloseAdd}>
          <form autocomplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>Kode Diskon *</Typography>
                <TextField
                  fullWidth
                  autoComplete="off"
                  placeholder="Kode Diskon"
                  value={discountCode}
                  error={!!errors.discountCode}
                  helperText={errors.discountCode}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setDiscountCode(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography>Tipe Diskon *</Typography>
                <TextField
                  fullWidth
                  select
                  value={discountType}
                  onChange={(e) => onChangeType(e.target.value)}
                >
                  {discountTypeArr.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.title}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Typography>Potongan Diskon *</Typography>
                <NumericFormat
                  fullWidth
                  autoComplete="off"
                  value={discountAmount}
                  onValueChange={(values) => onAmountChange(values.floatValue)}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  error={!!errors.discountAmount}
                  InputProps={{
                    startAdornment: discountType === 'H' ? (
                      <InputAdornment position="start">
                        Rp{" "}
                      </InputAdornment>
                    ) : null,
                    endAdornment: discountType === 'P' ? (
                      <InputAdornment position="start">
                        {" "}%
                      </InputAdornment>
                    ) : null
                  }}
                  disabled={discountType === 'N'}
                  variant="outlined"
                />
                {!!errors.discountAmount && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.discountAmount}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Minimum Pembelanjaan *</Typography>
                <NumericFormat
                  fullWidth
                  autoComplete="off"
                  value={minSpend}
                  onValueChange={(values) => setMinSpend(values.floatValue)}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  error={!!errors.minSpend}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        Rp{" "}
                      </InputAdornment>
                    )
                  }}
                  variant="outlined"
                />
                {!!errors.minSpend && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.minSpend}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Diskon Maksimum *</Typography>
                <NumericFormat
                  fullWidth
                  autoComplete="off"
                  value={maxDisc}
                  onValueChange={(values) => setMaxDisc(values.floatValue)}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  error={!!errors.maxDisc}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        Rp{" "}
                      </InputAdornment>
                    )
                  }}
                  disabled={discountType !== 'P'}
                  variant="outlined"
                />
                {!!errors.maxDisc && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.maxDisc}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Tanggal Start Diskon</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-sg">
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={discountStart}
                    onChange={(newValue) => setDiscountStart(newValue)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
                {!!errors.discountStart && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.discountStart}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Tanggal End Diskon</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-sg">
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={discountEnd}
                    onChange={(newValue) => setDiscountEnd(newValue)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
                {!!errors.discountEnd && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.discountEnd}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography>Deskripsi Diskon *</Typography>
                <TextareaAutosize
                  style={{ width: "100%" }}
                  minRows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {!!errors.description ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.description}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={addDiscount}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  {loading ? 'Mohon menunggu...' : 'Submit'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </LiqueModal>

        <LiqueModal open={openEdit} onClose={handleCloseEdit}>
          <form autocomplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography>Kode Diskon *</Typography>
                <TextField
                  fullWidth
                  autoComplete="off"
                  placeholder="Kode Diskon"
                  value={discountCode}
                  error={!!errors.discountCode}
                  helperText={errors.discountCode}
                  FormHelperTextProps={{ sx: { color: "red" } }}
                  onChange={(e) => setDiscountCode(e.target.value)}
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <Typography>Tipe Diskon *</Typography>
                <TextField
                  fullWidth
                  select
                  value={discountType}
                  onChange={(e) => onChangeType(e.target.value)}
                >
                  {discountTypeArr.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.title}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <Typography>Potongan Diskon *</Typography>
                <NumericFormat
                  fullWidth
                  autoComplete="off"
                  value={discountAmount}
                  onValueChange={(values) => onAmountChange(values.floatValue)}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  error={!!errors.discountAmount}
                  InputProps={{
                    startAdornment: discountType === 'H' ? (
                      <InputAdornment position="start">
                        Rp{" "}
                      </InputAdornment>
                    ) : null,
                    endAdornment: discountType === 'P' ? (
                      <InputAdornment position="start">
                        {" "}%
                      </InputAdornment>
                    ) : null
                  }}
                  variant="outlined"
                />
                {!!errors.discountAmount && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.discountAmount}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Minimum Pembelanjaan *</Typography>
                <NumericFormat
                  fullWidth
                  autoComplete="off"
                  value={minSpend}
                  onValueChange={(values) => setMinSpend(values.floatValue)}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  error={!!errors.minSpend}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        Rp{" "}
                      </InputAdornment>
                    )
                  }}
                  variant="outlined"
                />
                {!!errors.minSpend && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.minSpend}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Diskon Maksimum *</Typography>
                <NumericFormat
                  fullWidth
                  autoComplete="off"
                  value={maxDisc}
                  onValueChange={(values) => setMaxDisc(values.floatValue)}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  error={!!errors.maxDisc}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        Rp{" "}
                      </InputAdornment>
                    )
                  }}
                  disabled={discountType !== 'P'}
                  variant="outlined"
                />
                {!!errors.maxDisc && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.maxDisc}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Tanggal Start Diskon</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-sg">
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={discountStart}
                    onChange={(newValue) => setDiscountStart(newValue)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
                {!!errors.discountStart && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.discountStart}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography>Tanggal End Diskon</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-sg">
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={discountEnd}
                    onChange={(newValue) => setDiscountEnd(newValue)}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
                {!!errors.discountEnd && (
                  <FormHelperText error sx={{ color: "red" }}>
                    {errors.discountEnd}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography>Deskripsi Diskon *</Typography>
                <TextareaAutosize
                  style={{ width: "100%" }}
                  minRows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                {!!errors.description ? (
                  <FormHelperText sx={{ color: "red" }}>
                    {errors.description}
                  </FormHelperText>
                ) : null}
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  disabled={loading}
                  onClick={updateDiscount}
                  fullWidth
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  {loading ? 'Mohon menunggu...' : 'Edit'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </LiqueModal>

        <LiqueModal open={openDelete} onClose={handleCloseDelete} width="600px">
          <Box textAlign="center">
            <Typography id="spring-modal-title" variant="h6" component="h2">
              Apakah kamu yakin ingin membuang data ini?
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Button variant="outlined" onClick={handleCloseDelete}>
                Batal
              </Button>
              <Button
                variant="outlined"
                onClick={deleteDiscount}
                sx={{ ml: 2, backgroundColor: "red", color: "white" }}
                disabled={loading}
              >
                {loading ? 'Mohon menunggu...' : 'Buang'}
              </Button>
            </Box>
          </Box>
        </LiqueModal>
      </Container>
    </Box>
  )
}